import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AdumoeftApi} from 'src/app/api/adumoeft/adumoeft.api.class';
import {AdumoEftPaymentUpdateRequest} from "../../interfaces/adumoeft/Adumoeft";

@Injectable({
  providedIn: 'root'
})
export class AdumoeftService {

  constructor(private adumoeftEftApi: AdumoeftApi) {}

  initializePayment(sessionToken: string): Observable<any> {
    return this.adumoeftEftApi.initializePayment(sessionToken);
  }

  getTransactionStatus(sessionToken: string, adumoEftPaymentUpdateRequest: AdumoEftPaymentUpdateRequest): Observable<object> {
    return this.adumoeftEftApi.getTransactionStatus(sessionToken, adumoEftPaymentUpdateRequest);
  }

}
